export default __webpack_public_path__ + "static/media/1378F323-2E75-47BB-8F0A-F2B6587C7C27_1_105_c.bb98f3d1.jpeg";